<div class="quote-flow-stepper">
  <p-stepper [value]="activeStep()" [linear]="true">

    <!-- With no credit step there is only one panel, so the header would be decoration. -->
    @if (showStepHeader()) {
      <p-step-list>
        <p-step [value]="creditStepIndex()">
          <span class="yllw-step__label">{{ 'QUOTE.CREDIT_CHECK.DIALOG_TITLE' | translate }}</span>
        </p-step>
        <p-step [value]="confirmStepIndex()">
          <span class="yllw-step__label">{{ 'CREATE_ORDER.TABS.CONFIRMATION' | translate }}</span>
        </p-step>
      </p-step-list>
    }

    <p-step-panels>
      @if (showCreditStep()) {
        <p-step-panel [value]="creditStepIndex()">
          <ng-template #content>
            <app-credit-check-step
              stepMode="order"
              (proceed)="advanceFrom(creditStepIndex())"
              (cancelled)="cancel()" />
          </ng-template>
        </p-step-panel>
      }

      <p-step-panel [value]="confirmStepIndex()">
        <ng-template #content>
          <app-create-order-dialog [embedded]="true" [(creditCheckOK)]="creditCheckOK" />

          <!-- An explicit choice rather than two competing buttons. With two buttons the
               central-support toggle looked live whichever you were about to press, even though it
               is silently discarded on the order path. Nesting it inside the selected option makes
               its scope visible. -->
          @if (canSendToReview()) {
            <div class="quote-flow-stepper__choice">
              <p class="quote-flow-stepper__choice-question">
                {{ 'REVIEW_OR_CREATE_ORDER.SUBTEXT' | translate }}
              </p>

              <label class="quote-flow-stepper__option"
                     [class.is-selected]="destination() === 'review'">
                <p-radiobutton name="destination" value="review"
                               [ngModel]="destination()" (ngModelChange)="destination.set($event)"
                               inputId="destinationReview" />
                <div class="quote-flow-stepper__option-body">
                  <div class="quote-flow-stepper__option-heading">
                    <span>{{ 'REVIEW_OR_CREATE_ORDER.SEND_TO_REVIEW' | translate }}</span>
                  </div>
                  <p class="quote-flow-stepper__option-text">
                    {{ 'REVIEW_OR_CREATE_ORDER.REVIEW_EXPLANATION' | translate }}
                  </p>

                  <!-- Only rendered for the option it belongs to, so its state can never be
                       set and then silently thrown away. -->
                  @if (destination() === 'review') {
                    <app-send-order-to-review-dialog [embedded]="true" [(creditCheckOK)]="creditCheckOK" />
                  }
                </div>
              </label>

              <label class="quote-flow-stepper__option"
                     [class.is-selected]="destination() === 'order'">
                <p-radiobutton name="destination" value="order"
                               [ngModel]="destination()" (ngModelChange)="destination.set($event)"
                               inputId="destinationOrder" />
                <div class="quote-flow-stepper__option-body">
                  <div class="quote-flow-stepper__option-heading">
                    <span>{{ 'REVIEW_OR_CREATE_ORDER.CREATE_ORDER_BTN' | translate }}</span>
                  </div>
                  <p class="quote-flow-stepper__option-text">
                    {{ 'REVIEW_OR_CREATE_ORDER.CREATE_ORDER_EXPLANATION' | translate }}
                  </p>
                </div>
              </label>
            </div>
          }

          <!-- Last thing before the buttons: what the order is worth, and who gets credit for it.
               Below the destination choice on purpose — these are the figures you check on the way
               out, not a decision to make. -->
          <div class="quote-flow-stepper__summary">
            <app-create-order-summary />
          </div>

          <!-- One primary that carries out whichever destination is selected. -->
          <div class="quote-flow-stepper__footer">
            <p-button [label]="'ABORT' | translate" [text]="true" (onClick)="cancel()" />
            <p-button
              [label]="confirmLabelKey() | translate"
              [icon]="confirmLabelKey() === 'REVIEW_OR_CREATE_ORDER.SEND_TO_REVIEW' ? 'pi pi-send' : ''"
              [disabled]="!canConfirmSelected()"
              (onClick)="confirmSelected()" />
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
</div>
